import { UserLocation } from '../services/mapProviders/IMapService'

interface FallbackCity {
  name: string
  location: UserLocation
}

const TIMEZONE_TO_CITY: Record<string, FallbackCity> = {
  'Europe/London': { name: 'London', location: { latitude: 51.5074, longitude: -0.1278 } },
  'Europe/Paris': { name: 'Paris', location: { latitude: 48.8566, longitude: 2.3522 } },
  'Europe/Brussels': { name: 'Brussels', location: { latitude: 50.8503, longitude: 4.3517 } },
  'Europe/Luxembourg': { name: 'Luxembourg', location: { latitude: 49.6116, longitude: 6.1319 } },
  'Europe/Amsterdam': { name: 'Amsterdam', location: { latitude: 52.3676, longitude: 4.9041 } },
  'Europe/Berlin': { name: 'Berlin', location: { latitude: 52.5200, longitude: 13.4050 } },
  'Europe/Madrid': { name: 'Madrid', location: { latitude: 40.4168, longitude: -3.7038 } },
  'Europe/Rome': { name: 'Rome', location: { latitude: 41.9028, longitude: 12.4964 } },
  'Europe/Lisbon': { name: 'Lisbon', location: { latitude: 38.7223, longitude: -9.1393 } },
  'Europe/Zurich': { name: 'Zurich', location: { latitude: 47.3769, longitude: 8.5417 } },
  'Europe/Vienna': { name: 'Vienna', location: { latitude: 48.2082, longitude: 16.3738 } },
  'Europe/Dublin': { name: 'Dublin', location: { latitude: 53.3498, longitude: -6.2603 } },
  'Europe/Athens': { name: 'Athens', location: { latitude: 37.9838, longitude: 23.7275 } },
  'Europe/Warsaw': { name: 'Warsaw', location: { latitude: 52.2297, longitude: 21.0122 } },
  'Europe/Stockholm': { name: 'Stockholm', location: { latitude: 59.3293, longitude: 18.0686 } },
  'America/New_York': { name: 'New York', location: { latitude: 40.7128, longitude: -74.0060 } },
  'America/Los_Angeles': { name: 'Los Angeles', location: { latitude: 34.0522, longitude: -118.2437 } },
  'America/Chicago': { name: 'Chicago', location: { latitude: 41.8781, longitude: -87.6298 } },
  'America/Toronto': { name: 'Toronto', location: { latitude: 43.6532, longitude: -79.3832 } },
  'America/Montreal': { name: 'Montreal', location: { latitude: 45.5017, longitude: -73.5673 } },
}

const LANGUAGE_TO_CITY: Record<string, FallbackCity> = {
  'en-GB': TIMEZONE_TO_CITY['Europe/London'],
  'fr-FR': TIMEZONE_TO_CITY['Europe/Paris'],
  'fr-BE': TIMEZONE_TO_CITY['Europe/Brussels'],
  'fr-CA': TIMEZONE_TO_CITY['America/Montreal'],
  'nl-NL': TIMEZONE_TO_CITY['Europe/Amsterdam'],
  'nl-BE': TIMEZONE_TO_CITY['Europe/Brussels'],
  'de-DE': TIMEZONE_TO_CITY['Europe/Berlin'],
  'es-ES': TIMEZONE_TO_CITY['Europe/Madrid'],
  'it-IT': TIMEZONE_TO_CITY['Europe/Rome'],
  'pt-PT': TIMEZONE_TO_CITY['Europe/Lisbon'],
}

const DEFAULT_FALLBACK: FallbackCity = TIMEZONE_TO_CITY['Europe/Paris']

export function getFallbackLocation(): UserLocation & { method: string } {
  try {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
    const match = TIMEZONE_TO_CITY[timezone]
    if (match) {
      return { ...match.location, method: `Default (${match.name})` }
    }
  } catch {
    // Intl unavailable — fall through
  }

  const language = typeof navigator !== 'undefined' ? navigator.language : ''
  const langMatch = LANGUAGE_TO_CITY[language]
  if (langMatch) {
    return { ...langMatch.location, method: `Default (${langMatch.name})` }
  }

  return { ...DEFAULT_FALLBACK.location, method: `Default (${DEFAULT_FALLBACK.name})` }
}
